import React from 'react';
const ErrorPage = props => {
  return(
    <div>No route for {props.location.pathname}</div>
  )
}

export { ErrorPage }